__turbopack_context__.v({
  "card": "CollectionCards-module-scss-module__Hfnu9q__card",
  "card__body": "CollectionCards-module-scss-module__Hfnu9q__card__body",
  "card__description": "CollectionCards-module-scss-module__Hfnu9q__card__description",
  "card__image": "CollectionCards-module-scss-module__Hfnu9q__card__image",
  "card__media": "CollectionCards-module-scss-module__Hfnu9q__card__media",
  "card__title": "CollectionCards-module-scss-module__Hfnu9q__card__title",
  "cards": "CollectionCards-module-scss-module__Hfnu9q__cards",
  "cards--story": "CollectionCards-module-scss-module__Hfnu9q__cards--story",
  "cards--tinted": "CollectionCards-module-scss-module__Hfnu9q__cards--tinted",
  "cards__grid": "CollectionCards-module-scss-module__Hfnu9q__cards__grid",
  "cards__header": "CollectionCards-module-scss-module__Hfnu9q__cards__header",
  "cards__heading": "CollectionCards-module-scss-module__Hfnu9q__cards__heading",
});
